import { render, staticRenderFns } from "./MultiWhatsappChannelDetail.vue?vue&type=template&id=49d757a9&scoped=true"
import script from "./MultiWhatsappChannelDetail.vue?vue&type=script&lang=js"
export * from "./MultiWhatsappChannelDetail.vue?vue&type=script&lang=js"
import style0 from "./MultiWhatsappChannelDetail.vue?vue&type=style&index=0&id=49d757a9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d757a9",
  null
  
)

export default component.exports